import React, { useMemo } from "react";
import useGetStateFromCountries from "../../../hooks/useGetStateFromCountries";
import MultiSelectDropdown from "./base/MultiSelectDropdown";

const SelectWithStateFromCountries = ({ selectedStates, setSelectedStates, selectedCountries, displayEmpty }) => {
  const { states } = useGetStateFromCountries({
    countriesList: selectedCountries,
  });

  const values = useMemo(() => {
    return (states || []).map((state) => ({
      value: state,
      label: state,
    }));
  }, [states]);

  return (
    <MultiSelectDropdown
      key={selectedCountries.join(",")}
      title="app.report.states"
      values={values}
      value={selectedStates}
      defaultSelected={selectedStates}
      onChange={setSelectedStates}
      displayEmpty={displayEmpty}
      enableIntlOption={false}
      emptyMessage={!selectedCountries.length ? "app.state.noCountrySelected" : undefined}
    />
  );
};

export default React.memo(SelectWithStateFromCountries);
